import { Injectable } from '@angular/core';
import {ApiService} from '@xref/ngx';
import {map} from 'rxjs/operators';

export class Category {
  key: string;
  content: any;
}

@Injectable({
  providedIn: 'root'
})
export class CategoriesService {
  constructor(
    private api: ApiService
  ) {}

  dataMapper = (data: any): Category[] => data;

  getCategories() {
    return this.api.get('v1/category').pipe(map(this.dataMapper));
  }
}
